module.exports = __webpack_public_path__ + "static/iluni-1cd77bdcd301972600036fb4750d3a2c.png";